<template>
    <div class="detail">
        <div class="header" v-if="show">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                材料详情
            </div>
            <div class="right"></div>
        </div>
        <div class="main">
            <div class="img_box">
                <img v-for="(item,i) in img_list" :key="i+'img_li'" :src="item.previewUrl" alt="">
            </div>
            <div class="main-li">
                <p>材料名称</p>
                <span>{{info.mname}}</span>
            </div>
            <div class="main-li">
                <p>材料价格</p>
                <span>￥{{info.price}}</span>
            </div>
            <div class="main-li">
                <p>学科类型</p>
                <span>{{info.subjectType=='0'?'学科类':'非学科类'}}</span>
            </div>
            <div class="main-li">
                <p>使用期限</p>
                <span>{{info.useStartEndTime}}</span>
            </div>
            <div class="main-li">
                <p>材料描述</p>
                <span>{{info.describe}}</span>
            </div>
            <div class="main-li">
                <p>材料类型</p>
                <span>{{info.classify=='0'?'线上材料':'线下材料'}}</span>
            </div>
            <!-- 线上材料 -->
            <template v-if="info.classify=='0'">
                <div class="main-li">
                    <p>下载网站</p>
                    <span>{{info.downloadSite}}</span>
                </div>
                <div class="main-li">
                    <p>开发者</p>
                    <span>{{info.developerInfo}}</span>
                </div>
                <div class="main-li">
                    <p>资源主题</p>
                    <span>{{info.resourcesTheme}}</span>
                </div>
                <div class="main-li">
                    <p>资源简介</p>
                    <span>{{info.resourceProfile}}</span>
                </div>
                <div class="main-li">
                    <p>适用对象</p>
                    <span>{{info.suitableObject}}</span>
                </div>
                <div class="main-li">
                    <p>图文来源</p>
                    <span>{{info.graphicSource}}</span>
                </div>
            </template>
            <!-- 线下材料 -->
            <template v-if="info.classify=='1'">
                <div class="main-li">
                    <p>编写者</p>
                    <span>{{info.authorInfo}}</span>
                </div>
                <div class="main-li">
                    <p>材料简介</p>
                    <span>{{info.synopsis}}</span>
                </div>
                <div class="main-li">
                    <p>材料内容</p>
                    <span>{{info.content}}</span>
                </div>
                <div class="main-li">
                    <p>适用对象</p>
                    <span>{{info.suitableObject}}</span>
                </div>
            </template>
            <!-- <div class="main-title" style="margin-top:50px">
				<img src="./img/title-4.svg" alt="">
				<p>审核记录</p>
			</div>
            <div class="handle">
				<div v-for="(item,i) in info.operateList" :key="i+'材料审核记录'" class="handle-item">
					<img src="./img/reject.svg" alt="" v-if="item.auditState==='3'"/>
					<img src="./img/pass.svg" alt="" v-else/>
					<div class="handle-title">
						<p v-if="item.auditState">{{stateObj[item.auditState]}}</p>
						<p class="text">{{item.operateOpinion}}</p>
					</div>
					<span class="handle-name">{{item.operateOrgName || item.operateName}}</span>
					<span class="handle-time">{{ dayjs(item.operateTime).format('YYYY-MM-DD hh:mm') }}</span>
					<div class="line" v-if="i < item.operateOrgName.length-1"></div>
				</div>
			</div> -->
		</div>

    </div>
</template>
<script>
import util from '@/utils/util.js'
import dayjs from "dayjs";
export default {
	props:['info','type','show'],
	components:{
        
    },
	data() {
		return {
			img_list:[],
            stateObj:{
				'1':'申请审核',
				'2':'审核通过',
				'3':'审核不通过',
				'4':'已下架',
			},
		}
	},
	computed:{

	},
	watch: {
		info:{
			async handler(n,o){
                this.img_list= this.info.resource.filter(e=>e.source=='0');
			},
			deep:true
		}
	},
	created() {
		
	},
	methods: {
        dayjs,
		getFileType(ext){
			return util.getFileType(ext);
		},
        toIndex(){
            this.$emit('to-index')
        },
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
	height: 100%;
    padding: 0px 30px 30px 30px;
	overflow-y: auto;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.main{
		width: 100%;
		height: 100%;
		margin-top: 2%;
		.main-title{
			display: flex;
			align-items: center;
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
		.main-li{
			margin-top: 20px;
			width: 100%;
			display: flex;
			// align-items: center;
			font-size: 14px;
			color: #888;
			p{
				width: 120px;
				text-align: right;
				margin-right: 20px;
			}
			span{
				width: calc(100% - 220px);
				word-wrap:break-word;
			}
		}
	}
    .img_box{
        padding: 0 20px 0 70px;
        img{
            max-width: 350px;
            margin-right: 20px;
        }
    }
    .handle-item{
		width: 100%;
		height: 50px;
		margin-top: 20px;
		font-size: 14px;
		display: flex;
		align-items: flex-start;
		padding-left: 80px;
		position: relative;
		.line{
			position: absolute;
			width: 1px;
			height: calc(100% + 10px);
			background: #EEEEEE;
			left: 90px;
			top: calc(50% - 5px);
		}
		.handle-title{
			width: 50%;
			margin-left: 15px;
			.text{
				color: #888;
			}
		}
		.handle-name{
			width: 150px;
			text-align: right;
		}
		.handle-time{
			margin-left: 20px;
			color: #888;
		}
	}
}
</style>
